export const list_dashes = () => (
  <path
    d="M8.5 5h13.125M8.5 12h13.125M8.5 19h13.125M2.375 5h1.75m-1.75 7h1.75m-1.75 7h1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
